import { ISocketCommentProps } from '../types/working-model';
import { GetHv } from './helpers';

export function GetChat(sessionUuid: string, lang: string): Promise<ISocketCommentProps[]> {
	return GetHv(`/e3-chat-messages/${sessionUuid}/${lang}`);
}